// Helpers
import * as Url from 'helpers/url';


export function params(params) {
  return Url.toGet(params);
}
